export var FFormIdEnum;
(function (FFormIdEnum) {
    FFormIdEnum["BOOKING"] = "bookingForm";
    FFormIdEnum["SPECIAL_REQUEST_FORM"] = "specialRequestForm";
    FFormIdEnum["REVIEW_LIST_OPTIONS"] = "reviewListOptions";
    FFormIdEnum["CART_VALIDATION"] = "cartValidation";
})(FFormIdEnum || (FFormIdEnum = {}));
